import { render } from "./UsuarioModal.vue?vue&type=template&id=1b01f46a&scoped=true"
import script from "./UsuarioModal.vue?vue&type=script&lang=js"
export * from "./UsuarioModal.vue?vue&type=script&lang=js"

import "./UsuarioModal.vue?vue&type=style&index=0&id=1b01f46a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b01f46a"]])

export default __exports__